import { IsPositionChart } from "./IsPositionChart";
import { PositionConfig } from "../CoreApp/PositionConfig";

export const SynthesizePositions = chartMetadata => {
  if (!chartMetadata || !IsPositionChart(chartMetadata)) {
    return false;
  }

  const positionConfig = new PositionConfig(chartMetadata);

  return positionConfig.isPositionSynth() && positionConfig.isPositionDataIngestSingle();
};
